import type {
  FlowUpdateStorePogIdEntry,
  FlowUpdateStorePogTriggerError,
  FlowUpdateStorePogTriggerResponse,
} from "@CommonApi/merchflows/_merchflowId_/flow-update/_storePogTriggerId_";

export const isRecord = (value: unknown): value is Record<string, unknown> => {
  return typeof value === "object" && value !== null;
};

export const isStringArray = (value: unknown): value is string[] => {
  return Array.isArray(value) && value.every((entry) => typeof entry === "string");
};

export const isFlowUpdateStorePogTriggerError = (
  value: unknown,
): value is FlowUpdateStorePogTriggerError => {
  if (!isRecord(value)) {
    return false;
  }

  return typeof value["message"] === "string" && isStringArray(value["errors"]);
};

export const formatFlowUpdateStorePogTriggerError = (value: FlowUpdateStorePogTriggerError) => {
  return [value.message, ...value.errors].join("\n");
};

/** The pogs a Flow Update made for a store with an aisle break, which it may have laid a brand across. */
export const storePogIdsWhereBrandsMayCrossAisleBreak = (
  status: FlowUpdateStorePogTriggerResponse | null | undefined,
) => {
  const storePogIds = new Set<number>();
  if (!status || isFlowUpdateStorePogTriggerError(status)) return storePogIds;

  const entries: FlowUpdateStorePogIdEntry[] = Object.values(status.storePogIds ?? {});
  for (const { brandsMayCrossAisleBreak, updatedStorePogId } of entries) {
    if (brandsMayCrossAisleBreak && updatedStorePogId !== null) storePogIds.add(updatedStorePogId);
  }
  return storePogIds;
};
